import View from './View.js';
import previewView from './previewView.js';

class ResultsView extends View {
  _parentElement = document.querySelector('.results');
  _errorMessage = 'No recipes found for your query! please try again :)';
  _message;
  _generateMarkup() {
    return this._data.reduce(
      (result, recipe) => result + previewView.render(recipe, false),
      ''
    );
  }
}
export default new ResultsView();
